import Select2BaseController from './base_controller'

// select2 Search Dropdown without anything
// Usage: add "data-controller="select2--simple"" attribute to an HTML element
export default class extends Select2BaseController {
  connect() {
    $(this.element).select2({
      theme: 'bootstrap4',
      width: '100%',
      allowClear: true,
      placeholder: $(this.element).attr('placeholder') || '',
      selectionCssClass: 'select2-custom-selection',
      dropdownCssClass: 'select2-custom-dropdown',
    })

    super.connect()
  }
}
